import { useNavigate, useSearchParams } from "react-router-dom";
import { isTabId, TabId, TaskTab } from "src/components/ui/TaskTab";
import { useCallback } from "react";
import { ArrowLeft } from "lucide-react";
import RwoListView from "./RwoListView";
import DwoListView from "./DwoListView";

const TasksToday = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const tabParam = searchParams.get("tab");
  const activeTab: TabId = isTabId(tabParam) ? tabParam : "rwo";

  const changeTab = useCallback(
    (id: TabId) => {
      setSearchParams({ tab: id }, { replace: true });
    },
    [setSearchParams],
  );

  return (
    <div>
      <div className="sticky top-0 backdrop-blur-lg z-10">
        <div className="flex items-center gap-2 mb-2 ">
          <button
            className="cursor-pointer p-2 rounded-full hover:bg-gray-200 transition-colors ease-in duration-300"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft size={20} />
          </button>
          <p className="capitalize text-md text-primary font-semibold">
            Submitted Tasks
          </p>
        </div>
        <TaskTab active={activeTab} onChange={changeTab} />
      </div>

      <div
        role="tabpanel"
        id={`panel-${activeTab}`}
        aria-labelledby={`tab-${activeTab}`}
        tabIndex={0}
        className="outline-none focus-visible:ring-2 focus-visible:ring-primary rounded-lg"
      >
        {activeTab === "rwo" && <RwoListView />}

        {activeTab === "dwo" && <DwoListView />}
      </div>
    </div>
  );
};

export default TasksToday;
